import { useCallback } from "react";
import { ArrowRightIcon, FlagIcon } from "@heroicons/react/24/outline";
import { Button } from "@sablier/v2-components/molecules";
import { tags } from "@sablier/v2-constants";
import { useT } from "@sablier/v2-locales";
import { _ } from "@sablier/v2-mixins";
import { vendors } from "@sablier/v2-utils";
import {
  useAccount,
  useMachineCreateProxy,
  useModalTransaction,
  useResetter,
} from "~/client/hooks";
import { Base } from "../system";

function Proxy({ className }: { className?: string }) {
  const { t } = useT();

  const { send } = useMachineCreateProxy();
  const { signer, chainId } = useAccount();
  const { setOpen, updateData } = useModalTransaction();
  const { proxy: reset } = useResetter();

  const onClick = useCallback(() => {
    vendors.track.log("clickOnFinishAccountSetup");
    send("CREATE", {
      payload: {
        api: { reset, setOpen, t, updateData },
        signer,
        chainId,
      },
    });
  }, [chainId, reset, send, setOpen, signer, t, updateData]);

  return (
    <Base
      className={className}
      colors={{ content: "gray200", label: "white" }}
      cy={tags.warningProxy}
      description={t("warnings.proxy.description")}
      label={{ icon: FlagIcon, value: t("warnings.proxy.title") }}
    >
      <Button
        accent={"primaryNeon"}
        appearance={"outline"}
        isMini
        onClick={onClick}
        right={ArrowRightIcon}
        title={t("warnings.proxy.action")}
      />
    </Base>
  );
}

export default Proxy;
